import React from 'react';
import { TierCopy } from '../../services/deliveryAPI';

const RED = '#8B0000';

/**
 * The wholesale way through, on every tier of both surfaces (the registration flow and
 * the dashboard card).
 *
 * A farm in Twin Falls is a customer today, not a waiting-list entry, and a commercial
 * operation inside a delivery ZIP does not want bags carried to a bin either. It sits
 * below the main message so it never crowds the backyard flock - and it is always there,
 * because somebody scanning a QR code at an event needs a person to reach.
 *
 * Both the address and the number are tappable on a phone; "option 2" stays as text
 * because a tel: link cannot carry it reliably.
 */
const WholesaleLine: React.FC<{ wholesale: TierCopy['wholesale'] }> = ({ wholesale }) => (
  <div style={{
    marginTop: 12, paddingTop: 10, borderTop: '1px solid #f3f4f6',
    fontSize: 14, color: '#374151', lineHeight: 1.5,
  }}>
    <strong>{wholesale.question}</strong> {wholesale.text}
    {/* Two links in a wrapping row, no separator: a middle dot between them was left
        dangling at the end of the email line whenever the phone wrapped under it
        (Brad, 2026-09-24: "odd dot here"). */}
    <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 16, rowGap: 2 }}>
      <a href={`mailto:${wholesale.email}`} style={{ color: RED, fontWeight: 600 }}>
        {wholesale.email}
      </a>
      <a href={wholesale.phone_href} style={{ color: RED, fontWeight: 600, whiteSpace: 'nowrap' }}>
        {wholesale.phone}
      </a>
    </div>
  </div>
);

export default WholesaleLine;
